import React from "react";
import axios from "axios";
import {connect} from 'react-redux';
import {Redirect} from 'react-router'
import {Tooltip, OverlayTrigger, Row, Col, Grid, Badge, InputGroup, FormGroup} from 'react-bootstrap';
import {userActions} from "../../authentication/_actions";
import Button from "../CustomButton/CustomButton.jsx";
import ModalRestore from "../CustomModals/ModalRestore";
import ModalDelete from "../CustomModals/ModalDelete";
import {withNamespaces} from 'react-i18next';
import {ExportData} from "../CustomExport/ExportData";
import {get, set} from "../../functions/ChannelsSessionStorage";
import {loadImage} from "../../functions/LoadImages";
import ReactTableV6ServerSide from "../CustomDataTables/ReactTableV6ServerSide";
import {ModalPlaylist} from "../CustomModals/ModalPlaylist";
import ModalVideoPlayer from "../CustomModals/ModalVideoPlayer";
import Card from "../Card/Card";

class DataLiveChannels extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            remove_tooltip: (<Tooltip id="remove_tooltip">Remove</Tooltip>),
            restore_tooltip: (<Tooltip id="restore_tooltip">Restore</Tooltip>),
            edit_tooltip: (<Tooltip id="redit_tooltip">Edit</Tooltip>),
            preview_tooltip: (<Tooltip id="preview_tooltip">Preview</Tooltip>),
            download_playlist_tooltip: (
                <Tooltip id="download_playlist_tooltip">Download Channels as a Playlist</Tooltip>),
            export_excel_tooltip: (<Tooltip id="export_excel_tooltip">Export to excel</Tooltip>),

            redirect: false,

            channel_id: null,
            channel_iptv_url: null,
            channel_name_short: null,

            loading: true,
            channels: [],
            showRestoreModal: false,
            showDeleteModal: false,
            showPreviewModal: false,
            columns: [],
            data: [],

            sorted: [],
            filtered: [""],

            pages: null,
            page: 1,
            pageSize: 10,

            lastUpdate: null,
            filter: "",
            searchLiveTv: "",
            activePage: 0,
            totalItems: 0,
            totalPages: 0,

            mount: false,
            showModalPlaylist: false

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleOpenPlaylist = this.handleOpenPlaylist.bind(this);

    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        let dt = new Date();
        let utcDate = dt.toUTCString();

        if (name === "searchLiveTv") {

            if (this.props.listState === "removed") {
                set.removed_page_filter(value)
                set.removed_page("1");
            } else {
                set.active_page_filter(value)
                set.active_page("1");
            }

            this.setState({
                lastUpdate: utcDate,
                filtered: [''],
                filter: value,
                activePage: 1
            })
        }

    }

    handleUpdate() {
        this.getDataFromMiddleware()
    }

    handlePageSizeChange(size) {

        if (this.props.listState === "removed") {
            //REMOVED PAGE SIZE
            if (size.value !== null) {
                set.removed_page_size(size.value)
                set.removed_page(1)

                this.setState(
                    {
                        pageSize: size.value === null ? 10 : size.value,
                        filter: get.removed_page_filter(),
                        filtered: [''],
                        activePage: 1,
                        page: 1,
                        loading: true
                    }
                );

            } else {
                set.removed_page_size(10)
                set.removed_page(1)
                this.setState({pageSize: 10, loading: true});
            }
        } else {
            //ACTIVE PAGE SIZE
            if (size.value !== null) {
                set.active_page_size(size.value)
                set.active_page(1)

                this.setState(
                    {
                        pageSize: size.value === null ? 10 : size.value,
                        filter: get.active_page_filter(),
                        filtered: [''],
                        activePage: 1,
                        page: 1,
                        loading: true
                    }
                );
            } else {
                set.active_page_size(10)
                set.active_page(1)
                this.setState({pageSize: 10, loading: true});
            }
        }

    }

    handleSortChange(newSort) {

        if (this.props.listState === "removed") {
            set.removed_page_sort(newSort)
        } else {
            set.active_page_sort(newSort)
        }
        this.setState({sorted: newSort});
    }

    handlePageChange(pageNumber) {

        if (this.props.listState === "removed") {
            set.removed_page(pageNumber)
        } else {
            set.active_page(pageNumber)
        }

        set.active_page(pageNumber)

        this.setState({activePage: pageNumber, filtered: ['']});

    }

    handleOpenPlaylist() {
        this.setState({
            showModalPlaylist: true

        })
    }

    getDataFromMiddleware() {

        this.setState({loading: true})

        let myState = this.props.listState;
        let myUrl = process.env.REACT_APP_API_URL + "/Channels/";
        let page = 1;
        let pageSize = 10;
        let filter = '';

        if (myState === "removed") {
            myUrl = process.env.REACT_APP_API_URL + "/Channels/deleted";

            if (get.removed_page() === null) {
                page = 1
            } else {
                page = parseInt(get.removed_page(), 10)
            }

            if (get.removed_page_size() === null) {
                pageSize = 10
            } else {
                pageSize = parseInt(get.removed_page_size(), 10)
            }

            if (get.removed_page_filter() === null) {
                filter = '';
            } else {
                filter = get.removed_page_filter();
            }

        } else {
            if (get.active_page() === null) {
                page = 1
            } else {
                page = parseInt(get.active_page(), 10)
            }

            if (get.active_page_size() === null) {
                pageSize = 10
            } else {
                pageSize = parseInt(get.active_page_size(), 10)
            }

            if (get.active_page_filter() === null) {
                filter = '';
            } else {
                filter = get.active_page_filter();
            }

        }

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json',
            }
        };

        let postData = {
            channel: {
                type: this.props.listState,
                page: page,
                pageSize: pageSize,
                sorted: this.state.sorted,
                filtered: this.state.filtered,
                filter: filter
            }

        };

        axios.post(myUrl, postData, axiosConfig)
            .then((res) => {

                let totalPages = res.data['data'] === undefined ? 0 : res.data['data'][1][0].pages;
                let totalItems = res.data['data'] === undefined ? 0 : res.data['data'][0][0].TotalItems;

                this.setState({
                    channels: res.data['channels'],
                    pages: totalPages,
                    loading: false,
                    page: page,
                    totalItems,
                    totalPages,
                    activePage: page
                })

                if (page > 0 && totalPages === 0 && totalItems === 0 && page !== 1) {

                    page = page - 1

                    if (myState === "removed") {
                        set.removed_page(page)
                    } else {
                        set.active_page(page)
                    }

                    this.setState({
                        page: page,
                        activePage: page,
                        filtered: ['']
                    })
                }

            }).catch(error => {
            this.setState({loading: false});
            console.log(error);
        });

    }

    initSessionStorage() {

        if (this.props.listState === "removed") {

            //REMOVED PAGE
            if (get.removed_page() === null) {
                set.removed_page("1");
                this.setState({activePage: 1});
            } else {
                this.setState({activePage: parseInt(get.removed_page(), 10)});
            }

            //REMOVED PAGE SIZE
            if (get.removed_page_size() === null) {
                set.removed_page_size("10");
                this.setState({pageSize: 10});
            } else {
                this.setState({pageSize: parseInt(get.removed_page_size(), 10)});
            }

            //REMOVED FILTER
            if (get.removed_page_filter() === null) {
                set.removed_page_filter("")
            } else {
                this.setState({
                    filter: get.removed_page_filter(),
                    filtered: [''],
                    searchLiveTv: get.removed_page_filter()
                });
            }

            this.setState({mount: true});


        } else {

            //ACTIVE PAGE
            if (get.active_page() === null) {
                set.active_page("1");
                this.setState({activePage: 1});
            } else {
                this.setState({activePage: parseInt(get.active_page(), 10)});
            }

            //ACTIVE PAGE SIZE
            if (get.active_page_size() === null) {
                set.active_page_size("10");
                this.setState({pageSize: 10});
            } else {
                this.setState({pageSize: parseInt(get.active_page_size(), 10)});
            }

            //ACTIVE FILTER
            if (get.active_page_filter() === null) {
                set.active_page_filter("")
            } else {
                this.setState({
                    filter: get.active_page_filter(),
                    filtered: [''],
                    searchLiveTv: get.active_page_filter()
                });
            }

            this.setState({mount: true});

        }
    }

    componentDidMount() {

        this.loadReactLabels()

        this.initSessionStorage()

        this.getDataFromMiddleware()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.lastUpdate !== prevProps.lastUpdate) {
            this.getDataFromMiddleware()
        }
    }

    loadReactLabels() {

        let position_label = this.props.t('global.position', {framework: "react-i18next"})
        let status_label = this.props.t('global.status', {framework: "react-i18next"})
        let logo_label = this.props.t('global.logo', {framework: "react-i18next"})
        let name_label = this.props.t('global.name', {framework: "react-i18next"})
        let category_label = this.props.t('global.category', {framework: "react-i18next"})
        let resolution_label = this.props.t('global.resolution', {framework: "react-i18next"})
        // let mode_label = this.props.t('global.mode', {framework: "react-i18next"})
        let actions_label = this.props.t('global.actions', {framework: "react-i18next"})

        this.setState({
            columns: [
                {
                    accessor: "channel_id",
                    Header: "ID",
                    maxWidth: 50,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "channel_position",
                    Header: position_label,
                    maxWidth: 80,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "channel_bkp_position",
                    Header: "Secondary Position",
                    maxWidth: 140,
                    sortable: false,
                    filterable: false,
                    Cell: ({row, original}) => (
                        <div className="center">
                            {original.channel_bkp_position === null ? "" : original.channel_position + "." + original.channel_bkp_position}
                        </div>
                    )
                },
                {
                    accessor: "channel_status",
                    Header: status_label,
                    maxWidth: 100,
                    sortable: true,
                    filterable: false,
                    Cell: row => (
                        <div className="center">
                            <Badge fill="true" style={row.value === 1 ? {
                                background: '#87cb16',
                                borderRadius: '2px',
                                lineHeight: "2",
                                width: '60px'
                            } : {background: '#545557', borderRadius: '2px', "lineHeight": "2", width: '60px'}}>
                                {
                                    row.value === 1 ? 'Active' : 'Disabled'
                                }
                            </Badge>
                        </div>
                    )
                },
                {
                    accessor: "channel_image",
                    Header: logo_label,
                    maxWidth: 80,
                    sortable: false,
                    filterable: false,
                    Cell: row => (
                        <div className="center">
                            <img
                                src={loadImage.live_tv(row.value)}
                                width="90%"
                                // height="90%"
                                alt={""}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = process.env.REACT_APP_ASSET_URL + "/global/landscape_image_broken.png"
                                }}
                            />
                        </div>
                    )
                },
                {
                    accessor: "channel_name_long",
                    Header: name_label,
                    maxWidth: 300,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "cat_image",
                    Header: category_label,
                    maxWidth: 150,
                    sortable: false,
                    filterable: false,
                    Cell: ({row, original}) => (
                        <div className="center">
                            <img
                                src={loadImage.live_tv_cat(original.cat_image)}
                                width="50px"
                                height="90%"
                                alt={""}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = process.env.REACT_APP_ASSET_URL + "/global/landscape_image_broken.png"
                                }}
                            />
                            <span>
                                {" " + original.cat_name_short}
                            </span>
                        </div>
                    )
                },
                {
                    accessor: "channel_epg_name",
                    Header: "TVGuide",
                    maxWidth: 350,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "resolution_name",
                    Header: resolution_label,
                    maxWidth: 100,
                    sortable: true,
                    filterable: false
                },
                {
                    id: "stream_info",
                    Header: "Stream",
                    maxWidth: 260,
                    sortable: false,
                    filterable: false,
                    Cell: ({ original }) => (
                        <div style={{ fontSize: "11px", lineHeight: 1.3 }}>
                            <div><strong>Servers:</strong> {original.channel_servers || "-"}</div>
                            <div><strong>Stream app:</strong> {original.channel_application_name || "-"}</div>
                            <div><strong>Stream name:</strong> {original.channel_stream_name || "-"}</div>
                        </div>
                    )
                },
                {
                    Header: actions_label,
                    maxWidth: 200,
                    sortable: false,
                    filterable: false,
                    accessor: "channel_id",
                    Cell: ({row, original}) => (
                        <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            {this.setPreviewButton(original.channel_id, original.channel_iptv_url, original.channel_name_short)}
                            {this.setHelperButton(original.channel_id)}
                            {this.setDeleteButton(original.channel_id)}

                        </div>
                    )
                }
            ],
        });
    }


    setPreviewButton(channel_id, channel_iptv_url, channel_name_short) {

        // console.log(channel_iptv_url)

        return (<OverlayTrigger placement="top" overlay={this.state.preview_tooltip}>
            <Button
                onClick={() => this.setState({
                    channel_id: channel_id,
                    channel_iptv_url: channel_iptv_url,
                    channel_name_short: channel_name_short,
                    showPreviewModal: true
                })}

                bsStyle="success"
                simple
                icon
            >
                <i className="fa fa-play-circle"/>
            </Button>
        </OverlayTrigger>)

    }

    //BUTTONS
    setHelperButton(channel_id) {

        if (this.props.listState === "removed") {
            return (<OverlayTrigger placement="top" overlay={this.state.restore_tooltip}>
                <Button
                    onClick={() => this.setState({channel_id: channel_id, showRestoreModal: true})}

                    bsStyle="warning"
                    simple
                    icon
                >
                    <i className="fa fa-repeat"/>
                </Button>
            </OverlayTrigger>)
        } else {
            return (<OverlayTrigger placement="top" overlay={this.state.edit_tooltip}>
                <Button
                    onClick={() => {
                        this.setState({channel_id: channel_id})
                        this.setRedirect();
                    }}

                    bsStyle="info"
                    simple
                    icon
                >
                    <i className="fa fa-edit"/>
                </Button>
            </OverlayTrigger>)
        }


    }

    setDeleteButton(channel_id) {

        return (<OverlayTrigger placement="top" overlay={this.state.remove_tooltip}>
            <Button
                onClick={() => this.setState({channel_id: channel_id, showDeleteModal: true})}

                bsStyle="danger"
                simple
                icon
            >
                <i className="fa fa-times"/>
            </Button>
        </OverlayTrigger>)

    }

    //CHANNEL EDIT
    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {

        let path = "/edit-channel/" + this.state.channel_id;

        if (this.state.redirect) {
            return <Redirect push to={path}/>
        }
    }

    //ACTIONS
    restoreChannel(channel) {

        const deleteURL = process.env.REACT_APP_API_URL + "/Channels/restore/" + channel;

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };

        axios.delete(deleteURL, axiosConfig)
            .then((res) => {
                // let array = [...this.state.channels]; // make a separate copy of the array
                // const index = array.indexOf(channel)
                // array.splice(index, 1);
                // this.setState({channels: array});
                this.getDataFromMiddleware();
            })
            .catch(error => {
                //this.props.dispatch(userActions.logoutUnauthorized());
                console.log(error);
            });


    }

    deleteChannel(channel) {

        const deleteURL = process.env.REACT_APP_API_URL + "/Channels/" + channel;

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };

        axios.delete(deleteURL, axiosConfig)
            .then((res) => {
                // let array = [...this.state.channels]; // make a separate copy of the array
                // const index = array.indexOf(channel)
                // array.splice(index, 1);
                // this.setState({channels: array});
                this.getDataFromMiddleware();
            })
            .catch(error => {
                //this.props.dispatch(userActions.logoutUnauthorized());
                console.log(error);
            });


    }

    //MODALS
    setRestoreModal = (id, value, action) => {

        this.setState({
            showRestoreModal: value

        })

        if (action === "restore") {
            this.restoreChannel(id);
        }
    }

    setDisplayDeleteModal = (id, value, action) => {

        this.setState({
            showDeleteModal: value
        })

        if (action === "delete") {
            this.deleteChannel(id)
        }
    }

    setDisplayPreviewModal = (id, value, action) => {

        this.setState({
            channel_id: null,
            showPreviewModal: false
        })

    }

    renderRestoreModal = () => {

        if (this.state.showRestoreModal) {
            console.log("Clicked Restore Modal...");
            return <ModalRestore
                headerMessage={"Restore Channel"}
                bodyMessage={"this action will restore the channel to the list of active channels but in disabled state"}
                handlerFromParent={this.setRestoreModal}
                handlerID={this.state.channel_id}
            />
        }
    }

    renderPreviewModal = () => {

        if (this.state.showPreviewModal) {
            return <ModalVideoPlayer
                headerMessage={this.state.channel_id + " - " + this.state.channel_name_short}
                bodyMessage={""}
                handlerFromParent={this.setDisplayPreviewModal}
                handlerID={this.state.channel_iptv_url}
            />
        }
    }

    renderDeleteModal = () => {

        let bodyMessageVar = "this action will disable the channel and move it to removed state. This action can be undone";

        if (this.props.listState === "removed") {
            bodyMessageVar = "this action will permanently delete the channel and there is no way to restore the state";
        }

        if (this.state.showDeleteModal) {
            console.log("Clicked Delete Modal...");
            return <ModalDelete
                headerMessage={"Delete Channel"}
                bodyMessage={bodyMessageVar}
                handlerFromParent={this.setDisplayDeleteModal}
                handlerID={this.state.channel_id}
            />
        }
    }

    renderReactChannels = () => {

        if (this.state.mount) {
            return (
                <ReactTableV6ServerSide
                    columns={this.state.columns}
                    data={this.state.channels}
                    loading={this.state.loading}
                    pageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.pages}
                    activePage={this.state.activePage}
                    totalItems={this.state.totalItems}
                    location={"channels"}
                    filter={this.state.filter}
                    filtered={this.state.filtered}
                    sorted={this.state.sorted}
                    parentHandlerPageChange={this.handlePageChange}
                    parentHandlerSortChange={this.handleSortChange}
                    parentHandlerPageSizeChange={this.handlePageSizeChange}
                    parentHandlerRequestUpdate={this.handleUpdate}
                />
            )
        }

    }

    clearSearchButton() {

        let dt = new Date();
        let utcDate = dt.toUTCString();
        let value = "";

        if (this.props.listState === "removed") {
            sessionStorage.setItem('removed_live_page_filter', value)
            sessionStorage.setItem('removed_live_page', "1");
        } else {
            sessionStorage.setItem('active_live_page_filter', value)
            sessionStorage.setItem('active_live_page', "1");
        }

        this.setState({
            lastUpdate: utcDate,
            filtered: [''],
            filter: value,
            activePage: 1,
            searchLiveTv: ""
        })

    }

    renderPlaylistModal = () => {

        if (this.state.showModalPlaylist) {

            return (
                <ModalPlaylist
                    handlerFromParent={this.setDisplayPlaylistModal}
                    handlerSource="channels"
                    customer="sadmin"/>
            );
        }

    }

    setDisplayPlaylistModal = (id, value) => {

        this.setState({
            showModalPlaylist: value

        })

    }

    render() {
        return (
            <div>

                {this.renderRedirect()}
                {this.renderRestoreModal()}
                {this.renderDeleteModal()}
                {this.renderPlaylistModal()}
                {this.renderPreviewModal()}

                <Card
                    content={
                        <div>
                            <Grid fluid>
                                <Row>
                                    <Col md={12}>
                                        <div className="pull-left">
                                            <h5>
                                                {this.props.listName}
                                            </h5>
                                        </div>
                                        <div className="pull-left">
                                            <ExportData
                                                listState={this.props.listState}
                                                exportDataFor={"channels"}
                                            />
                                        </div>
                                        <div className="pull-left">
                                            <OverlayTrigger placement="right"
                                                            overlay={this.state.download_playlist_tooltip}>
                                                <Button simple icon onClick={this.handleOpenPlaylist.bind(this)}
                                                        bsStyle="default">
                                                    <i className="fa fa-download"> </i>
                                                </Button>
                                            </OverlayTrigger>
                                        </div>

                                        <div className="pull-right" style={{width: "250px"}}>

                                            <FormGroup>
                                                <InputGroup>
                                                    <input
                                                        className="form-control form-control-sm ml-3 w-75"
                                                        type="text"
                                                        placeholder="Search"
                                                        aria-label="Search"
                                                        name="searchLiveTv"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.searchLiveTv || ""}
                                                    />
                                                    <InputGroup.Addon>
                                                        <i style={{color: this.state.searchLiveTv !== "" ? "#f7263b" : "#343434"}}
                                                           className={this.state.searchLiveTv !== "" ? "fa fa-times" : "fa fa-search"}
                                                           onClick={this.clearSearchButton.bind(this)}/>
                                                    </InputGroup.Addon>
                                                </InputGroup>
                                            </FormGroup>

                                        </div>

                                    </Col>
                                </Row>
                            </Grid>

                            <legend/>

                            {this.renderReactChannels()}

                        </div>


                    }
                />

            </div>
        );

    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDataLiveChannels = connect(mapStateToProps)(DataLiveChannels);
const connectedDataLiveChannelsTrans = withNamespaces('common')(connectedDataLiveChannels);
export {connectedDataLiveChannelsTrans as DataLiveChannels};
